export const changeBG = url => dispatch => {
  dispatch({
    type: 'CHANGE_BG',
    bg: url,
  })
}
